module.exports = __webpack_public_path__ + "static/media/panosta-svg-80x80.f5edada7.svg";